import { Injectable, signal } from '@angular/core';
import {
  StytchBaseUrl,
  StytchPublicToken,
  StytchWhiteLabel,
} from './stytch-public-token';

interface StytchConfigResponse {
  stytch_public_token: string;
  stytch_base_host: string;
  white_label: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class StytchSetup {
  private readonly publicTokenSig = signal('');
  private readonly baseHostSig = signal('');
  private readonly whiteLabelSig = signal(false);

  static async storeConfig() {
    const resp = await fetch('/anubis/v1/auth-config');
    if (resp.ok) {
      const config: StytchConfigResponse = await resp.json();
      sessionStorage.setItem(this.publicTokenKey(), config.stytch_public_token);
      sessionStorage.setItem(this.baseHostKey(), config.stytch_base_host || '');
      sessionStorage.setItem(this.whiteLabelKey(), `${config.white_label}`);

      return Promise.resolve();
    } else {
      return Promise.reject(
        'Could not load auth config. Please refresh your browser.'
      );
    }
  }

  private static publicTokenKey() {
    return `${StytchPublicToken}:${location.hostname}`;
  }

  private static baseHostKey() {
    return `${StytchBaseUrl}:${location.hostname}`;
  }

  private static whiteLabelKey() {
    return `${StytchWhiteLabel}:${location.hostname}`;
  }

  publicToken() {
    if (!this.publicTokenSig()) {
      const token = sessionStorage.getItem(StytchSetup.publicTokenKey());
      this.publicTokenSig.set(token);
    }
    return this.publicTokenSig();
  }

  baseHost() {
    if (!this.baseHostSig()) {
      const host = sessionStorage.getItem(StytchSetup.baseHostKey());
      this.baseHostSig.set(host);
    }
    return this.baseHostSig();
  }

  whiteLabel() {
    if (!this.whiteLabelSig()) {
      const whiteLabel = sessionStorage.getItem(StytchSetup.whiteLabelKey());
      this.whiteLabelSig.set(whiteLabel === 'true');
    }
    return this.whiteLabelSig();
  }
}
